import dice from '@/store/modals.dice.js'

const modules = {
	dice,
}

const state = {
	detail: {
		show: false,
		title: '',
		content: '',
	},
	numeric: {
		show: false,
	},
	vitals: {
		show: false,
	},
	account: {
		login: {
			show: false,
		},
		characters: {
			show: false,
			loading: false,
			versions: {
				show: false,
				loading: false,
				character: '',
			}
		},
		error: false,
		errorMessage: '',
	},
}

const getters = {

}

const actions = {
	showDetails({ commit }, payload) {
		commit('showDetail', payload)
	},
	hideDetails({ commit }) {
		commit('hideDetail')
	},
	showLogin({ commit }) {
		commit('showLogin')
	},
	hideLogin({ commit }) {
		commit('hideLogin')
	},
	showCharacters({ commit }) {
		commit('showCharacters')
	},
	hideCharacters({ commit }) {
		commit('hideCharacters')
	},
	setCharactersLoading({ commit }, value) {
		commit('setCharactersLoading',value)
	},
	showCharacterVersions({ commit }) {
		commit('showCharacterVersions')
	},
	hideCharacterVersions({ commit }) {
		commit('hideCharacterVersions')
	},
	setCharacterVersionsLoading({ commit }, value) {
		commit('setCharacterVersionsLoading',value)
	},
	setCharacter({ commit }, value) {
		commit('setCharacter',value)
	},
	setError({ commit }, payload) {
		commit('setError', payload)
	},
	clearError({ commit }, payload) {
		commit('clearError', payload)
	}
}

const mutations = {
	show (state, what) {
		state[what].show = true
	},
	hide (state, what) {
		state[what].show = false
	},
	set (state, what, value) {
		state[what].show = value
	},
	showDetail (state, detail) {
		state.detail.show = true
		state.detail.title = detail.title || state.detail.title
		state.detail.content = detail.content || state.detail.content
	},
	hideDetail (state) {
		state.detail.show = false
	},
	showLogin (state) {
		state.account.login.show = true
	},
	hideLogin (state) {
		state.account.login.show = false
	},
	showCharacters (state) {
		state.account.characters.show = true
	},
	hideCharacters (state) {
		state.account.characters.show = false
	},
	setCharactersLoading (state, value) {
		state.account.characters.loading = value
	},
	showCharacterVersions (state) {
		state.account.characters.versions.show = true
	},
	hideCharacterVersions (state) {
		state.account.characters.versions.show = false
	},
	setCharacterVersionsLoading (state, value) {
		state.account.characters.versions.loading = value
	},
	setCharacter (state, value) {
		state.account.characters.versions.character = value
	},
	setError (state, payload) {
		state[payload.module].error = true
		state[payload.module].errorMessage = payload.message
	},
	clearError (state, payload) {
		state[payload.module].error = false
		state[payload.module].errorMessage = ''
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
	modules,
}